import { Controller } from "@hotwired/stimulus"

// The page-level dialog that shows one email preview at its real size.
//
// One instance serves every locale tab: it holds no email HTML at rest and is
// filled from the `email-preview:expand` event that the thumbnail dispatches,
// so neither locale's rendered email is duplicated in the DOM while the dialog
// is closed. It lives outside the `lifecycle_template_preview` Turbo Frame so a
// template change, which replaces that frame, leaves it alone.
export default class extends Controller {
  static targets = ["frame", "subject", "locale", "widthButton"]

  static values = { defaultWidth: { type: Number, default: 600 } }

  open(event) {
    const { srcdoc, subject, locale } = event.detail

    this.frameTarget.srcdoc = srcdoc
    this.subjectTarget.textContent = subject || ""
    this.localeTarget.textContent = (locale || "").toUpperCase()

    // Reset rather than inherit: the toggle is a way to look at this email, not
    // a preference, and a dialog that reopens in mobile after an unrelated
    // template change misreports what is about to be sent.
    this.applyWidth(this.defaultWidthValue)

    this.element.showModal()
  }

  close() {
    this.element.close()
  }

  // Bound to the dialog's own `close` event, so Escape and the backdrop release
  // the HTML the same way the close button does.
  closed() {
    this.frameTarget.srcdoc = ""
  }

  setWidth(event) {
    this.applyWidth(Number(event.currentTarget.dataset.width))
  }

  applyWidth(width) {
    this.frameTarget.style.width = `${width}px`

    this.widthButtonTargets.forEach((button) => {
      const active = Number(button.dataset.width) === width
      button.setAttribute("aria-pressed", String(active))
      button.classList.toggle("bg-white", active)
      button.classList.toggle("shadow-sm", active)
      button.classList.toggle("text-gray-900", active)
      button.classList.toggle("text-gray-500", !active)
    })
  }
}
